import "./business-info.css";
import { BusinessInfoProps } from "./business-info.props";
import { useEffect, useState } from "react";
import ImageUploader from "src/components/molecules/imageUploader/imageUploader";
import { IBusinessInfoModel, IFileInfo } from "src/types/models/apiModels";
import InputBox from "src/components/atoms/v2/inputBox/inputBox";

const BusinessInfo: React.FC<BusinessInfoProps> = ({ info, onChange }) => {
	const defaultImage = "https://placehold.co/150x150.png";
	const [businessInfo, setBusinessInfo] = useState<IBusinessInfoModel>(
		info ?? {
			businessId: "",
			businessCode: "",
			name: "",
			website: "",
			industry: "",
			dunsNumber: "",
			status: "New",
			countryCode: "AU",
		}
	);
	const [selectedImage, setSelectedImage] = useState(defaultImage);

	useEffect(() => {
		if (onChange) {
			onChange(businessInfo);
		}
	}, [businessInfo]);

	const handleFieldChange = (
		field: keyof typeof businessInfo,
		value: string
	) => {
		setBusinessInfo((prevInfo: IBusinessInfoModel) => ({
			...prevInfo,
			[field]: value,
		}));
	};
	const handleImageUpload = async (image: IFileInfo | undefined) => {
		setBusinessInfo((prevInfo: IBusinessInfoModel) => ({
			...prevInfo,
			logo: image,
		}));
		setSelectedImage(image?.signedUrl ?? defaultImage);
	};

	return (
		<>
			<div className="flex flex-col items-center justify-center gap-4 w-full">
				<div className="flex items-center justify-start gap-2 w-full">
					<span className="font-Poppins font-medium text-2xl uppercase tracking-wider">
						Business Details
					</span>
				</div>
				<div className="flex flex-col items-start justify-center w-full gap-4">
					<ImageUploader
						image={businessInfo.logo}
						onUploadSuccess={handleImageUpload}
					/>
					<div className="flex flex-col items-center justify-start w-full gap-4">
						<InputBox
							label={"Business Name"}
							type={"text"}
							value={businessInfo?.name ?? ""}
							onChange={(value) =>
								handleFieldChange("name", value)
							}
							required
						></InputBox>
						<InputBox
							label={"Website"}
							type={"url"}
							value={businessInfo?.website ?? ""}
							onChange={(value) =>
								handleFieldChange("website", value)
							}
						></InputBox>
						<InputBox
							label={"Duns Number"}
							type={"text"}
							value={businessInfo?.dunsNumber ?? ""}
							onChange={(value) =>
								handleFieldChange("dunsNumber", value)
							}
							required
						></InputBox>
					</div>
				</div>
			</div>
		</>
	);
};

export default BusinessInfo;
